import React, { Component } from "react";
import Icon from "../../../components/Library/Icon/Icon";
import SubscribeButton from "../../../components/Library/SubscribeButton";

import styles from "./Subscribe.css";

class Subscribe extends Component {

  render() {
    const { subscription } = this.props;
    if (!subscription) return null;

    return (
      <div>
        <div className={styles.content}>
          <div className={styles.text}>
            <strong>{subscription.name}</strong>
            <div>{subscription.description}</div>
          </div>
        </div>
        {
          subscription.isSubscribed ?
            <SubscribeButton className={styles.subscribed} disabled>
              <Icon name="check/rounded" className={styles.check}/>
              Subscribed
            </SubscribeButton> :
            <SubscribeButton className={styles.subscribe} onClickSubscribe={this.props.onClickSubscribe}>
              Subscribe
            </SubscribeButton>
        }
      </div>
    );
  }
}

export default Subscribe;
